module.exports = __webpack_public_path__ + "images/img-klients.0583fc46.jpg";